@use 'variables' as *;
@use 'mixins' as *;

:host {
  display: block;
}

:host([hidden]) {
  display: none;
}
